import React, { PureComponent } from "react";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { numberWithCommas, kmFormatter, intToRGB, hashCode, convertToTitleCase } from "../utils";
import moment from "moment-timezone";
import UpIcon from "../../../../../assets/svg/percentage_arrow.svg";
import DownIcon from "../../../../../assets/svg/arrow-down.svg";
import NoData from "../NoData/NoData";
import { MetricsList } from "../../../AdvancedCustomChart/MetricsList";
import { connect } from "react-redux";
import HC_brokenAxis from "highcharts/modules/broken-axis";
HC_brokenAxis(Highcharts);
class AdvanceCustomChartDisplayEditMode extends PureComponent {
    constructor(props) {
        super(props);
        this.chartComponent = React.createRef();
    }
    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent?.current?.chart.setSize(null, null);
                this.chartComponent?.current?.chart.reflow();
            }, 100);
        });

        if (this.props.widgetContainerRef?.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        }
    }
    componentWillUnmount() {
        this.ro.disconnect();
    }
    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.chartName !== this.props.chartName) {
            return false;
        }
        return true;
        // return false;
    }

    getTwoDimensionTwoMetricBarOptions = () => {
        let redrawingEnabled = true;

        const adjustLegendHeight = (chart) => {
            chart.legend.update({
                maxHeight: chart.chartHeight / 4,
            });
        };

        const sortedData = (chartSource) => {
            var series = chartSource.series;
            // var axis = chartSource.xAxis[0];
            var categories = [];

            const countryCounts = {};
            if (series[0]?.data) {
                if (series)
                    series.forEach((obj) => {
                        obj.stack === "common" &&
                            obj.data.forEach((item) => {
                                const country = item.name;
                                const count = item.y;

                                if (countryCounts[country]) {
                                    countryCounts[country] += count;
                                } else {
                                    countryCounts[country] = count;
                                }
                            });
                    });

                const countryCountArray = Object.entries(countryCounts).map(([name, count]) => ({ name, count }));

                // console.log("firstchartSource", chartSource, countryCountArray);

                if (Array.isArray(series)) {
                    var ser = series.find(function (ser) {
                        return ser;
                    });

                    ser.data.forEach(function (datum) {
                        var obj = {
                            name: datum.name,
                            index: ser.data.indexOf(datum),
                            stackTotal: countryCountArray.filter((ele) => ele.name == datum.name)[0].count,
                            breakDownId: datum.breakDownId,
                            breakdownDimensionName: datum.breakdownDimensionName,
                            // color: datum.color,
                            dataId: datum.dataId,
                            dimensionName: datum.dimensionName,
                            yAxisName: datum.yAxisName,
                        };
                        categories.push(obj);
                    });
                }

                categories.sort(function (a, b) {
                    var aName = a.name.toLowerCase();
                    var bName = b.name.toLowerCase();
                    var aTotal = a.stackTotal;
                    var bTotal = b.stackTotal;
                    if (aTotal === bTotal) {
                        return aName < bName ? -1 : aName > bName ? 1 : 0;
                    } else {
                        return aTotal > bTotal ? -1 : aTotal < bTotal ? 1 : 0;
                    }
                });

                // const breakDownId = categories.slice(function (category) {
                //     return category.breakDownId;
                // });
                // const breakdownDimensionName = categories.slice(function (category) {
                //     return category.breakdownDimensionName;
                // });
                // const color = categories.slice(function (category) {
                //     return category.color;
                // });
                // const dataId = categories.slice(function (category) {
                //     return category.dataId;
                // });
                // const dimensionName = categories.slice(function (category) {
                //     return category.dimensionName;
                // });
                // const yAxisName = categories.slice(function (category) {
                //     return category.yAxisName;
                // });

                var mappedIndex = categories.map(function (category) {
                    return category.index;
                });

                categories = categories.map(function (category) {
                    return category.name;
                });
                // console.log("serdataa", categories, series, mappedIndex);
                series.forEach(function (ser) {
                    var data = mappedIndex.map(function (mappedIndex, i) {
                        return {
                            name: ser.data[mappedIndex]?.name,
                            y: ser.data[mappedIndex]?.y || 0,
                            breakDownId: ser.data[mappedIndex]?.breakDownId,
                            breakdownDimensionName: ser.data[mappedIndex]?.breakdownDimensionName,
                            dataId: ser.data[mappedIndex]?.dataId,
                            dimensionName: ser.data[mappedIndex]?.dimensionName,
                            yAxisName: ser.data[mappedIndex]?.yAxisName,
                            breakDownName: ser.data[mappedIndex]?.breakDownName,
                        };
                    });
                    ser.data = data;
                });

                // console.log("categoriesseriesserser", series, mappedIndex, ser);

                return ser;
            }
        };

        let chartConfig = {};
        // let data = this.props.data?.minimizedData ? JSON.parse(JSON.stringify(this.props.data?.minimizedData)) : JSON.parse(JSON.stringify(this.props.data));
        let data = JSON.parse(JSON.stringify(this.props.data));
        let chartData = [];

        // chartData.push(JSON.parse(JSON.stringify(data.leftYAxis.data)));
        // chartData.push(JSON.parse(JSON.stringify(data.rightYAxis.data)));

        // let total = this.props.data.total;
        let self = this;
        chartData = data.leftYAxis.data.map((element, index) => [element, data.rightYAxis.data[index]]).flat();
        // chartData = [...data.leftYAxis.data, ...data.rightYAxis.data];

        let YAxisLabel = MetricsList.metrics.filter((ele) => ele.label == this.props.multiDimensionChartConfig.breakdownMetricName.label);
        let YAxisLabel1 = MetricsList.metrics.filter((ele) => ele.label == this.props.multiDimensionChartConfig.metricName.label);
        let xAxisLabel1 = this.props.multiDimensionChartConfig.dimensionName.value;
        let xAxisLabel2 = this.props.multiDimensionChartConfig.breakdownDimensionName.value;

        chartConfig = {
            chart: {
                type: "column",
                backgroundColor: "transparent",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
                events: {
                    render: function () {
                        if (redrawingEnabled) {
                            // disable redrawing to prevent infinite recursive redraw() loop (update() fires redraw by default)
                            redrawingEnabled = false;

                            adjustLegendHeight(this);

                            // enable redrawing after update and redraw are finished
                            redrawingEnabled = true;
                        }
                    },
                    load: function () {
                        Highcharts.addEvent(this.tooltip, "headerFormatter", function (e) {
                            if (!e.isFooter) {
                                e.text = `<b> ${xAxisLabel1} - ${e.labelConfig.key}</b><br/>
                <span style="border:0px solid gray;display:block;border-radius:4px;width:300px;padding:0px 1px;">
                <span style="dispaly:inline-block;margin-bottom:20px;border-right:0px solid gray;padding:3px;">
                <span style="display:inline-block;width:114px;"><b>${xAxisLabel2} </b></span></span> 
                <span style="display:inline-block;padding:1px 2px;width:42px;"><b> ${
                    e.labelConfig.point.yAxisName == "Mention" ? "Volume of Conversation" : e.labelConfig.point.yAxisName
                }</b></span>`;
                                return false; // prevent default
                            }
                            return true; // run default
                        });
                    },
                },
                // title: "",
            },
            title: {
                text: ``,
            },
            credits: {
                enabled: false,
            },

            xAxis: [
                {
                    type: "category",
                    // reversed: xAxisLabel1 == "Published Date" ? true : false,
                },
            ],
            yAxis: [
                {
                    // Primary yAxis

                    gridLineWidth: 2,
                    gridLineDashStyle: "ShortDash",
                    gridLineColor: "#ccd6eb",
                    lineColor: "#ccd6eb",
                    lineWidth: 1,
                    // title: {
                    //     text: this.props.advCustomChartReducer.multiDimensionChartConfig.metricName,
                    // },
                    opposite: true,
                    title: {
                        text: YAxisLabel[0].value,
                    },
                    stackLabels: {
                        style: {
                            color: "blue",
                        },
                        enabled: true,
                        formatter: function () {
                            //  console.log("firsttotsl", this);
                            return kmFormatter(this.total);
                        },
                    },
                },
                {
                    // Secondary yAxis

                    gridLineWidth: 2,
                    gridLineDashStyle: "ShortDash",
                    gridLineColor: "#ccd6eb",
                    lineColor: "#ccd6eb",
                    lineWidth: 1,
                    title: {
                        text: YAxisLabel1[0].value,
                    },
                    stackLabels: {
                        style: {
                            color: "blue",
                        },
                        enabled: true,
                        formatter: function () {
                            // console.log("firsttotsl", this);
                            return kmFormatter(this.total);
                        },
                    },
                    // title: {
                    //     text: this.props.advCustomChartReducer.multiDimensionChartConfig.breakdownMetricName,
                    // },
                },
            ],
            plotOptions: {
                column: {
                    stacking: "normal",
                    // showInLegend: true,

                    // grouping: false,
                    //  dataSorting: {
                    //     enabled: true,
                    //     sortKey: 'y'
                    // },

                    borderWidth: 0,
                    minPointLength: 8,
                    dataLabels: {
                        enabled: true,
                        inside: true,
                        formatter: function () {
                            if (this.point.shapeArgs.height < this.point.name?.length * 2) {
                                return;
                            } else {
                                return kmFormatter(this.y);
                            }

                            // return kmFormatter(this.y);
                        },
                        style: {
                            color: "white",
                            textOutline: "none",
                            fontFamily: "'Roboto', sans-serif",
                        },
                    },
                },
            },
            tooltip: {
                // followPointer: true,
                // followTouchMove: true,
                // shared: true,
                backgroundColor: "#fff",
                borderColor: "#fff",
                borderRadius: 6,
                useHTML: true,
                shadow: false,
                // headerFormat: `<span style="display:block;margin-bottom:5px"><b>{point.point.main_subtopic_name}</b></span>`,
                padding: 10,
                opacity: 1,
                outside: true,
                style: {
                    zIndex: 200000,
                    opacity: 1,
                    backgroundColor: "#ff6633",
                },
                // width: 800,

                pointFormatter: function () {
                    let allSeries = this.series.chart.series;
                    let toolTipData = ``;
                    let topicTotal = this.total;

                    allSeries.forEach((ele, i) => {
                        if (this.yAxisName == ele.points[this.index]?.yAxisName) {
                            let visibleLegend = this.series.chart.legend.allItems.filter((element) => element.name == ele.points[this.index]?.breakDownName);

                            visibleLegend.forEach((e) => {
                                let reqObject = ele.points.filter((item) => item.category == this.category);
                                if (e.visible && reqObject[0]?.y != 0) {
                                    toolTipData += `<span style="border:0px solid gray;display:block;border-radius:4px;width:300px;padding:0px 1px;"><span style="dispaly:inline-block;margin-bottom:20px;border-right:0px solid gray;padding:3px;"> <span style="margin-right:4px;display:inline-block;width:8px;height:8px;background-color:${
                                        reqObject[0]?.color
                                    };border-radius:10px" ></span> <span style="display:inline-block;width:114px;">${
                                        reqObject[0]?.breakDownName
                                    } </span></span> <span style="display:inline-block;padding:1px 2px;width:42px;"> ${
                                        ((reqObject[0]?.y * 100) / topicTotal).toFixed(1) + "%"
                                    }</span> <span style="display:inline-block;padding:1px">(${numberWithCommas(reqObject[0]?.y)} / ${numberWithCommas(
                                        topicTotal,
                                    )})</span><br/> </span>`;
                                }
                            });
                        }
                    });

                    return toolTipData;
                },
            },
            series: chartData,
        };

        xAxisLabel1 !== "Published Date" && sortedData(chartConfig);

        return chartConfig;
    };

    getOneDimensionTwoMetricBarOptions = () => {
        let chartConfig = {};
        let data = JSON.parse(JSON.stringify(this.props.data));
        let chartData = [];

        chartData.push(JSON.parse(JSON.stringify(data.leftYAxis)));
        chartData.push(JSON.parse(JSON.stringify(data.rightYAxis)));

        // let total = this.props.data.total;
        // let self = this;
        let xAxisLabel = this.props.multiDimensionChartConfig.dimensionName.value;

        chartConfig = {
            chart: {
                type: "column",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            title: {
                text: ``,
            },
            credits: {
                enabled: false,
            },

            xAxis: [
                {
                    type: "category",
                },
            ],
            yAxis: [
                {
                    // Primary yAxis

                    title: {
                        text: chartData[1].name,
                    },
                    gridLineWidth: 2,
                    gridLineDashStyle: "shortdash",
                    gridLineColor: "#ccd6eb",
                    lineColor: "#ccd6eb",
                    lineWidth: 1,
                    opposite: true,
                    stackLabels: {
                        style: {
                            color: "blue",
                        },
                        enabled: true,
                        formatter: function () {
                            return kmFormatter(this.total);
                        },
                    },
                },
                {
                    // Secondary yAxis
                    title: {
                        text: chartData[0].name,
                    },
                    gridLineWidth: 2,
                    gridLineDashStyle: "shortdash",
                    gridLineColor: "#ccd6eb",
                    lineColor: "#ccd6eb",
                    lineWidth: 1,
                    stackLabels: {
                        style: {
                            color: "blue",
                        },
                        enabled: true,
                        formatter: function () {
                            return kmFormatter(this.total);
                        },
                    },

                    // opposite: true,
                },
            ],

            plotOptions: {
                column: {
                    // grouping: false,
                    stacking: "normal",
                    showInLegend: true,
                    borderWidth: 0,
                    minPointLength: 8,

                    dataLabels: {
                        enabled: true,
                        inside: true,
                        formatter: function () {
                            if (this.point.shapeArgs.height < this.point.name?.length * 2) {
                                return;
                            } else {
                                return kmFormatter(this.y);
                            }
                            // return kmFormatter(this.y);
                        },
                        style: {
                            color: "white",
                            textOutline: "none",
                            fontFamily: "'Roboto', sans-serif",
                        },
                    },
                    events: {},
                },
            },
            tooltip: {
                // shared: true,
                backgroundColor: "#fff",
                borderColor: "#fff",
                borderRadius: 6,
                // followPointer: true,
                followTouchMove: true,
                useHTML: true,
                formatter: function () {
                    return `
                    <span style="display:inline-block;"><b>${xAxisLabel}</b></span><br />
                    <span style="padding:2px 0px;">${this.key}</span><br />
                    <br/>
                    <span style="display:inline-block;"><b> ${this.series.name} </b></span>
                     <br />
                    <span style="display:inline-block;">${numberWithCommas(this.y)} </span>
                    </span>`;
                },
            },

            series: chartData,
            // [
            //     {
            //         name: "share_count",
            //         type: "column",
            //         yAxis: 1,
            //         data: [
            //             {
            //                 name: "Twitter",
            //                 y: 16491,
            //             },

            // ],
        };
        return chartConfig;
    };

    getTwoDimensionOneMetricBarOptions = () => {
        let redrawingEnabled = true;

        const adjustLegendHeight = (chart) => {
            chart.legend.update({
                maxHeight: chart.chartHeight / 4,
            });
        };

        const sortedData = (chartSource) => {
            var series = chartSource.series;
            // var axis = chartSource.xAxis[0];
            var categories = [];

            const countryCounts = {};
            if (series[0]?.data) {
                if (series)
                    series.forEach((obj) => {
                        obj.data.forEach((item) => {
                            const country = item.name;
                            const count = item.y;

                            if (countryCounts[country]) {
                                countryCounts[country] += count;
                            } else {
                                countryCounts[country] = count;
                            }
                        });
                    });

                const countryCountArray = Object.entries(countryCounts).map(([name, count]) => ({ name, count }));

                if (Array.isArray(series)) {
                    var ser = series.find(function (ser) {
                        return ser;
                    });

                    ser.data.forEach(function (datum) {
                        var obj = {
                            name: datum.name,
                            index: ser.data.indexOf(datum),
                            stackTotal: countryCountArray.filter((ele) => ele.name == datum.name)[0].count,
                            breakDownId: datum.breakDownId,
                            breakdownDimensionName: datum.breakdownDimensionName,
                            // color: datum.color,
                            dataId: datum.dataId,
                            dimensionName: datum.dimensionName,
                            yAxisName: datum.yAxisName,
                        };
                        categories.push(obj);
                    });
                }

                categories.sort(function (a, b) {
                    var aName = a.name.toLowerCase();
                    var bName = b.name.toLowerCase();
                    var aTotal = a.stackTotal;
                    var bTotal = b.stackTotal;
                    if (aTotal === bTotal) {
                        return aName < bName ? -1 : aName > bName ? 1 : 0;
                    } else {
                        return aTotal > bTotal ? -1 : aTotal < bTotal ? 1 : 0;
                    }
                });

                // const breakDownId = categories.slice(function (category) {
                //     return category.breakDownId;
                // });
                // const breakdownDimensionName = categories.slice(function (category) {
                //     return category.breakdownDimensionName;
                // });
                // const color = categories.slice(function (category) {
                //     return category.color;
                // });
                // const dataId = categories.slice(function (category) {
                //     return category.dataId;
                // });
                // const dimensionName = categories.slice(function (category) {
                //     return category.dimensionName;
                // });
                // const yAxisName = categories.slice(function (category) {
                //     return category.yAxisName;
                // });

                var mappedIndex = categories.map(function (category) {
                    return category.index;
                });

                categories = categories.map(function (category) {
                    return category.name;
                });

                series.forEach(function (ser) {
                    var data = mappedIndex.map(function (mappedIndex, i) {
                        return {
                            name: ser.data[mappedIndex]?.name,
                            y: ser.data[mappedIndex]?.y || 0,
                            breakDownId: ser.data[mappedIndex]?.breakDownId,
                            breakdownDimensionName: ser.data[mappedIndex]?.breakdownDimensionName,
                            dataId: ser.data[mappedIndex]?.dataId,
                            dimensionName: ser.data[mappedIndex]?.dimensionName,
                            yAxisName: ser.data[mappedIndex]?.yAxisName,
                            breakDownName: ser.data[mappedIndex]?.breakDownName,
                        };
                    });
                    ser.data = data;
                });

                return ser;
            }
        };

        let chartConfig = {};

        let data = this.props.data && JSON.parse(JSON.stringify(this.props.data));
        let chartData = [];
        chartData = data;

        var breaks = new Map();
        let YAxisLabel = MetricsList.metrics.filter((ele) => ele.label == this.props.multiDimensionChartConfig.metricName.label);
        let xAxisLabel1 = this.props.multiDimensionChartConfig.dimensionName.value;
        let xAxisLabel2 = this.props.multiDimensionChartConfig.breakdownDimensionName.value;

        chartConfig = {
            chart: {
                type: "column",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },

                events: {
                    render: function () {
                        if (redrawingEnabled) {
                            // disable redrawing to prevent infinite recursive redraw() loop (update() fires redraw by default)
                            redrawingEnabled = false;
                            adjustLegendHeight(this);
                            // enable redrawing after update and redraw are finished
                            redrawingEnabled = true;
                        }
                    },
                    load: function () {
                        Highcharts.addEvent(this.tooltip, "headerFormatter", function (e) {
                            if (!e.isFooter) {
                                e.text = `<b> ${xAxisLabel1} - ${e.labelConfig.key}</b><br/>
                <span style="border:0px solid gray;display:block;border-radius:4px;width:300px;padding:0px 1px;">
                <span style="dispaly:inline-block;margin-bottom:20px;border-right:0px solid gray;padding:3px;">
                <span style="display:inline-block;width:114px;"><b>${xAxisLabel2} </b></span></span> 
                <span style="display:inline-block;padding:1px 2px;width:42px;"><b> ${
                    e.labelConfig.point.yAxisName == "Mention" || e.labelConfig.point.yAxisName == "mention"
                        ? "Volume of Conversation"
                        : e.labelConfig.point.yAxisName
                }</b></span>`;
                                return false; // prevent default
                            }
                            return true; // run default
                        });
                    },
                },
            },
            title: {
                text: ``,
            },
            credits: {
                enabled: false,
            },

            xAxis: [
                {
                    type: "category",
                    reversed: xAxisLabel1 == "Published Date" ? true : false,
                },
            ],
            yAxis: [
                {
                    // Primary yAxis
                    gridLineWidth: 2,
                    gridLineDashStyle: "ShortDash",
                    gridLineColor: "#ccd6eb",
                    lineColor: "#ccd6eb",
                    lineWidth: 1,
                    title: {
                        text: YAxisLabel[0].value,
                    },
                    stackLabels: {
                        style: {
                            color: "blue",
                        },
                        enabled: true,
                        allowOverlap: false,
                        formatter: function () {
                            return kmFormatter(this.total);
                        },
                    },
                },
            ],

            plotOptions: {
                column: {
                    grouping: false,
                    stacking: "normal",
                    dataSorting: {
                        enabled: xAxisLabel1 == "Published Date" ? true : false,
                        sortKey: "name",
                    },
                    showInLegend: true,
                    borderWidth: 0,
                    minPointLength: this.y > 2 ? 8 : 4,
                    dataLabels: {
                        enabled: true,
                        inside: true,
                        // crop: false,
                        // overflow: "none",
                        formatter: function () {
                            // if (this.y > 0) {

                            if (this.point.shapeArgs.height < this.point.name?.length * 2) {
                                return;
                            } else {
                                return kmFormatter(this.y);
                            }

                            // }
                        },
                        style: {
                            color: "white",
                            textOutline: "none",
                            fontFamily: "'Roboto', sans-serif",
                        },
                    },
                    // events: {
                    //     legendItemClick: function () {
                    //         console.log("firstbreakss", breaks);
                    //         if (breaks.has(this.xData[0])) {
                    //             breaks.delete(this.xData[0]);
                    //         } else {
                    //             breaks.set(this.xData[0], { from: this.xData[0] - 0.5, to: this.xData[0] + 0.5, breakSize: 0 });
                    //         }

                    //         this.chart.xAxis[0].update({
                    //             breaks: [...breaks.values()],
                    //         });
                    //     },
                    // },
                },
            },
            // tooltip: {
            //     // shared: true,
            //     backgroundColor: "#fff",
            //     borderColor: "#fff",
            //     borderRadius: 6,
            //     // followPointer: true,
            //     followTouchMove: true,
            //     useHTML: true,
            //     formatter: function () {
            //         return `
            //         <span style="display:inline-block;"><b>${xAxisLabel1}</b></span><br />
            //         <span style="padding:2px 0px;">${this.key}</span><br />
            //         <br/>
            //         <span style="padding:2px 0px;"><b>${xAxisLabel2}</b></span><br />
            //         <span style="padding:2px 0px;">${this.series.name}</span><br />
            //         <br/>
            //         <span>
            //         <span style="display:inline-block;"><b>${
            //             this.point.yAxisName == "Mention" || this.point.yAxisName == "mention"
            //                 ? "Volume of Conversation"
            //                 : this.series.userOptions?.data[0]?.yAxisName
            //         } </b></span>
            //         </span> <br />
            //         <span style="display:inline-block;">${numberWithCommas(this.y)} (${this.percentage.toFixed(2)}%)</span>
            //         </span>`;
            //     },
            // },

            // tooltip: {
            //     followPointer: true,
            //     followTouchMove: true,
            //     shared: true,
            //     backgroundColor: "#fff",
            //     borderColor: "#fff",
            //     borderRadius: 6,
            //     useHTML: true,
            //     shadow: false,
            //     // headerFormat: `<span style="display:block;margin-bottom:5px"><b>{point.point.main_subtopic_name}</b></span>`,
            //     padding: 10,
            //     opacity: 1,
            //     outside: false,
            //     style: {
            //         zIndex: 200000,
            //         opacity: 1,
            //         backgroundColor: "#ff6633",
            //     },
            //     // width: 800,

            //     pointFormatter: function () {
            //         let counnt = 0;
            //         console.log("firstfunction", this, ++counnt);

            //         let toolTipData = ``;
            //         let ColumnHeading = ``;

            //         if (topicTotal != 0 && this.y != 0) {
            //             // ColumnHeading =;
            //         }
            //         let topicTotal = this.total;
            //         if (topicTotal != 0 && this.y != 0) {
            //             console.log("counnt", ++counnt);
            //             toolTipData += `<span style="border:0px solid gray;display:block;border-radius:4px;width:300px;padding:0px 1px;"><span style="dispaly:inline-block;margin-bottom:20px;border-right:0px solid gray;padding:3px;"> <span style="margin-right:4px;display:inline-block;width:8px;height:8px;background-color:${
            //                 this.color
            //             };border-radius:10px" ></span> <span style="display:inline-block;width:114px;">${
            //                 this.options.breakDownName
            //             } </span></span> <span style="display:inline-block;padding:1px 2px;width:42px;"> ${
            //                 ((this.y * 100) / topicTotal).toFixed(1) + "%"
            //             }</span> <span style="display:inline-block;padding:1px">(${numberWithCommas(this.y)} / ${numberWithCommas(
            //                 topicTotal,
            //             )})</span><br/> </span>`;
            //         }
            //         return toolTipData;
            //     },
            // },
            tooltip: {
                backgroundColor: "#fff",
                borderColor: "#fff",
                borderRadius: 6,
                useHTML: true,
                shadow: false,
                padding: 10,
                opacity: 1,
                outside: true,
                style: {
                    zIndex: 200000,
                    opacity: 1,
                    backgroundColor: "#ff6633",
                },
                // width: 800,

                pointFormatter: function () {
                    let allSeries = this.series.chart.series;
                    let toolTipData = ``;
                    let topicTotal = this.total;

                    allSeries.forEach((ele, i) => {
                        if (this.yAxisName == ele.points[this.index]?.yAxisName) {
                            let visibleLegend = this.series.chart.legend.allItems.filter((element) => element.name == ele.points[this.index]?.breakDownName);

                            visibleLegend.forEach((e) => {
                                let reqObject = ele.points.filter((item) => item.category == this.category);
                                if (e.visible && reqObject[0]?.y != 0) {
                                    toolTipData += `<span style="border:0px solid gray;display:block;border-radius:4px;width:300px;padding:0px 1px;"><span style="dispaly:inline-block;margin-bottom:20px;border-right:0px solid gray;padding:3px;"> <span style="margin-right:4px;display:inline-block;width:8px;height:8px;background-color:${
                                        reqObject[0]?.color
                                    };border-radius:10px" ></span> <span style="display:inline-block;width:114px;">${
                                        reqObject[0]?.breakDownName
                                    } </span></span> <span style="display:inline-block;padding:1px 2px;width:42px;"> ${
                                        ((reqObject[0]?.y * 100) / topicTotal).toFixed(1) + "%"
                                    }</span> <span style="display:inline-block;padding:1px">(${numberWithCommas(reqObject[0]?.y)} / ${numberWithCommas(
                                        topicTotal,
                                    )})</span><br/> </span>`;
                                }
                            });
                        }
                    });

                    return toolTipData;
                },
            },

            series: chartData,
        };
        // if (typeof chartConfig.series == "function") {
        sortedData(chartConfig);
        // }

        return chartConfig;
    };
    getOneDimensionOneMetric = () => {
        let chartConfig = {};
        let data = this.props.data && JSON.parse(JSON.stringify(this.props.data));
        let chartData = [];

        // chartData.push(JSON.parse(JSON.stringify(data.leftYAxis.data)));
        // chartData.push(JSON.parse(JSON.stringify(data.rightYAxis.data)));

        // let total = this.props.data.total;
        chartData = data;
        let YAxisLabel = MetricsList.metrics.filter((ele) => ele.label == this.props.multiDimensionChartConfig.metricName.label);

        // let self = this;
        // chartData = [...chartData, ...data[0]];

        var breaks = new Map();

        let xAxisLabel = this.props.multiDimensionChartConfig.dimensionName.value;
        let yAxisLabel1 = this.props.multiDimensionChartConfig.metricName.value;
        chartConfig = {
            chart: {
                type: "column",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
                // title: "",
            },
            title: {
                text: ``,
            },
            credits: {
                enabled: false,
            },

            xAxis: [
                {
                    type: "category",
                },
            ],
            yAxis: [
                {
                    // Primary yAxis

                    title: {
                        text: YAxisLabel[0].value,
                    },
                    gridLineWidth: 2,
                    gridLineDashStyle: "shortdash",
                    gridLineColor: "#ccd6eb",
                    lineColor: "#ccd6eb",
                    lineWidth: 1,
                    stackLabels: {
                        style: {
                            color: "blue",
                        },
                        enabled: true,
                        formatter: function () {
                            return kmFormatter(this.total);
                        },
                    },
                },
            ],
            plotOptions: {
                series: {
                    borderWidth: 0,
                    minPointLength: 8,
                    // stacking: "normal",

                    dataLabels: {
                        enabled: true,
                        inside: true,
                        formatter: function () {
                            if (this.point.shapeArgs.height < this.point.name?.length * 2) {
                                return;
                            } else {
                                return kmFormatter(this.y);
                            }

                            // return kmFormatter(this.y);
                        },
                        style: {
                            color: "white",
                            textOutline: "none",
                        },
                    },
                    events: {
                        legendItemClick: function () {
                            if (breaks.has(this.xData[0])) {
                                breaks.delete(this.xData[0]);
                            } else {
                                breaks.set(this.xData[0], { from: this.xData[0] - 0.5, to: this.xData[0] + 0.5, breakSize: 0 });
                            }

                            this.chart.xAxis[0].update({
                                breaks: [...breaks.values()],
                            });
                        },
                    },
                },
                column: {
                    grouping: false,
                    stacking: "normal",
                },
            },
            tooltip: {
                // shared: true,
                backgroundColor: "#fff",
                borderColor: "#fff",
                borderRadius: 6,
                followPointer: true,
                followTouchMove: true,
                useHTML: true,
                formatter: function () {
                    return `
                    <span style="display:inline-block;"><b>${xAxisLabel}</b></span><br />
                    <span style="padding:2px 0px;">${this.key}</span><br />
                    <br/>
                    <span style="display:inline-block;"><b>${yAxisLabel1} </b></span><br/>
                    <span style="padding:2px 0px;">${numberWithCommas(this.y)}</span>
                    `;
                },
            },
            legend: {
                enabled: true,
                itemStyle: {
                    fontWeight: 500,
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "normal",
                },
            },
            series: chartData,
        };
        return chartConfig;
    };

    render() {
        let isDimensionsAndMetricsAdded = this.props.multiDimensionChartConfig.dimensionName === "" || this.props.multiDimensionChartConfig.metricName === "";

        return (
            <>
                {this.props.data &&
                    !this.props.nodata &&
                    this.props.data?.leftYAxis &&
                    this.props.multiDimensionChartConfig.dimensionName?.label?.trim().length > 0 &&
                    this.props.multiDimensionChartConfig.breakdownDimensionName?.label?.trim().length > 0 &&
                    this.props.multiDimensionChartConfig.metricName?.label?.trim().length > 0 &&
                    this.props.multiDimensionChartConfig.breakdownMetricName?.label?.trim().length > 0 && (
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={this.getTwoDimensionTwoMetricBarOptions()}
                            ref={this.chartComponent}
                            containerProps={{ style: { width: "100%", height: "calc(100% - 0px)" } }}
                        />
                    )}

                {this.props.data &&
                    !this.props.nodata &&
                    this.props.multiDimensionChartConfig.dimensionName?.label?.trim().length > 0 &&
                    this.props.multiDimensionChartConfig.breakdownDimensionName?.label?.trim().length > 0 &&
                    this.props.multiDimensionChartConfig.metricName?.label?.trim().length > 0 &&
                    this.props.multiDimensionChartConfig.breakdownMetricName == "" && (
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={this.getTwoDimensionOneMetricBarOptions()}
                            ref={this.chartComponent}
                            containerProps={{ style: { width: "100%", height: "calc(100% - 0px)" } }}
                        />
                    )}

                {this.props.data &&
                    !this.props.nodata &&
                    this.props.data?.leftYAxis &&
                    this.props.multiDimensionChartConfig.dimensionName?.label?.trim().length > 0 &&
                    this.props.multiDimensionChartConfig.metricName?.label?.trim().length > 0 &&
                    this.props.multiDimensionChartConfig.breakdownDimensionName == "" &&
                    this.props.multiDimensionChartConfig.breakdownMetricName?.label?.trim().length > 0 && (
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={this.getOneDimensionTwoMetricBarOptions()}
                            ref={this.chartComponent}
                            containerProps={{ style: { width: "100%", height: "calc(100% - 0px)" } }}
                        />
                    )}

                {this.props.data &&
                    !this.props.nodata &&
                    this.props.multiDimensionChartConfig.dimensionName?.label?.trim().length > 0 &&
                    this.props.multiDimensionChartConfig.metricName?.label?.trim().length > 0 &&
                    this.props.multiDimensionChartConfig.breakdownDimensionName == "" &&
                    this.props.multiDimensionChartConfig.breakdownMetricName == "" && (
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={this.getOneDimensionOneMetric()}
                            ref={this.chartComponent}
                            containerProps={{ style: { width: "100%", height: "calc(100% - 0px)" } }}
                        />
                    )}
                {(this.props.data == undefined || isDimensionsAndMetricsAdded || this.props.nodata) && (
                    <NoData
                        message={
                            this.props.filters.topics.length == 0 &&
                            this.props.filters.subtopics.length == 0 &&
                            (this.props.multiDimensionChartConfig.dimensionName.label == "topics_data" ||
                                this.props.multiDimensionChartConfig.dimensionName.label == "sub_topics_data")
                                ? "To view charts, please select topics using either the page filters on the left or the chart filters on this chart."
                                : null
                        }
                        advanceChartNoDimensionsAndMetrics={isDimensionsAndMetricsAdded}
                    />
                    // <NoData advanceChartNoDimensionsAndMetrics={isDimensionsAndMetricsAdded} />
                )}
            </>
        );
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        multiDimensionChartConfig: state.advCustomChartReducer.multiDimensionChartConfig,
        chartName: state.advCustomChartReducer.chartName,
        filters: state.dashboardReducer.filters,
    };
};

export default connect(mapStateToProps)(AdvanceCustomChartDisplayEditMode);
